<template>
  <div class="pages">
    <div class="filter">
      <div>
        <el-form size="small" :inline="true">
          <el-form-item label="管理员类型">
            <el-select
              clearable
              v-model="formInline.type"
              @change="getAdminList(1, 10)"
            >
              <el-option
                :label="v.name"
                :value="v.value"
                v-for="(v, i) in typeList"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="学校">
              <el-select
                clearable
                v-model="formInline.schoolId"
                placeholder="请选择学校"
              >
                <el-option
                  v-for="item in schoolList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          <el-form-item label="选择日期">
            <el-date-picker
              @change="getAdminList(1, 10)"
              v-model="formInline.dateValue"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
            >
            </el-date-picker>
          </el-form-item>
        </el-form>
      </div>
      <div class="search">
        <el-form size="small" :inline="true">
          <el-form-item label="关键字">
            <el-input
              v-model="formInline.keyWord"
              placeholder="请输入关键词查询"
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="searcList">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="table">
      <el-button
        v-if="$store.state.userinfo.isSuper"
        type="primary"
        size="medium"
        @click="addAdminBtn"
        >添加管理员</el-button
      >
      <el-table :data="tableData" height="5.7rem" max-height="5.7rem">
        <el-table-column type="index" label="序号" align="center" width="50">
        </el-table-column>
        <el-table-column property="name" label="真实姓名" align="center">
        </el-table-column>
        <el-table-column property="adminType" label="管理员类型" align="center">
          <template slot-scope="scope">
            <p v-if="scope.row.adminType === 0">校级管理员</p>
            <p v-else-if="scope.row.adminType === 1">教职工管理员</p>
            <p v-else-if="scope.row.adminType === 2">学生管理员</p>
          </template>
        </el-table-column>
        <el-table-column
          property="schoolName"
          label="管理员所属学校"
          align="center"
        >
        </el-table-column>
        <el-table-column
          property="creationTime"
          label="管理员认证时间"
          align="center"
        >
        </el-table-column>
        <el-table-column label="操作" align="center" width="340">
          <template slot-scope="scope">
            <el-button
              v-if="
                (!scope.row.imgFront ||
                  !scope.row.imgReverse ||
                  !scope.row.imgWork) &&
                  $store.state.userinfo.isSuper
              "
              @click="uploadAuth(scope.row)"
              type="text"
              size="medium"
              >上传认证信息</el-button
            >
            <el-button
              v-if="
                $store.state.userinfo.adminType === 0 ||
                  $store.state.userinfo.isSuper
              "
              @click="openAuth(scope.row)"
              type="text"
              size="medium"
              >权限管理</el-button
            >
            <el-button @click="handleClick(scope.row)" type="text" size="medium"
              >详情</el-button
            >
            <el-button
              v-if="
                $store.state.userinfo.adminType === 0 ||
                  $store.state.userinfo.isSuper
              "
              @click="cancelGLY(scope.row)"
              type="text"
              size="medium"
              style="color: #f56c6c"
              >撤销</el-button
            >
            <el-button
              v-if="
                scope.row.adminType === 0 &&
                  $store.state.userinfo.id == scope.row.userId
              "
              @click="returnAuth(scope.row)"
              type="text"
              size="medium"
              >转让身份</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <div class="pages justify-end">
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="currentSize"
          layout="  prev, pager, next,  sizes, jumper"
          :total="totalCount"
        >
        </el-pagination>
      </div>
    </div>
    <!-- 授权弹窗 -->
    <el-dialog :title="authTitle" :visible.sync="authDialog" width="30%">
      <div style="height: 50vh;overflow-y: scroll;">
        <el-tree
          :data="AuthTreeData"
          show-checkbox
          node-key="id"
          ref="areaTrees"
          :props="props"
          check-on-click-node
          :default-expand-all="true"
          :check-strictly="true"
          :expand-on-click-node="false"
          @node-click="nodeClick"
          :default-checked-keys="currAuthArr"
          @check="handleCheck"
        >
        </el-tree>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="authDialog = false" style="margin-left: 50px;"
          >取 消</el-button
        >
        <el-button type="primary" @click="onEditAuth">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 添加管理员 -->
    <el-dialog
      :title="popTitle"
      :visible.sync="dialogFormVisible"
      :destroy-on-close="true"
      width="50%"
      @close="closeAddForm"
    >
      <addAdmin
        :isSee="isSee"
        ref="schoolDetail"
        :closeDetials="closeDetials"
        :getSchoolList="getAdminList"
        :currAdminInfo="currAdminInfo"
        :dialogFormVisible="dialogFormVisible"
      ></addAdmin>
      <span slot="footer" class="dialog-footer">
        <el-button
          v-if="!isSee"
          @click="amendDetials"
          type="primary"
          size="medium"
          >确 定</el-button
        >
        <el-button
          v-if="isSee"
          @click="amendDetials2"
          type="primary"
          size="medium"
          >确 定</el-button
        >
        <el-button @click="closeDetials">关 闭</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%"
      @close="resetForm"
    >
      <span
        >系统中已存在相同账号数据，是否直接将该用户设置为管理员并更新认证信息？</span
      >
      <span class="dialog-footer" slot="footer">
        <el-button @click="setAdmin(false)">仅设置为管理员</el-button>
        <el-button type="primary" @click="setAdmin(true)">确定</el-button>
      </span>
    </el-dialog>

    <!-- 转让身份 -->
    <el-dialog
      title="转让身份"
      :destroy-on-close="true"
      width="30%"
      :visible.sync="dialogReturnVisible"
      @close="closeReturnVisible"
    >
      <el-form label-width="1.2rem">
        <el-form-item label="教职工管理员：">
          <el-select
            style="width: 100%;"
            clearable
            v-model="sensitiveTeacher"
            placeholder="请选择教职工管理员"
          >
            <el-option
              v-for="item in schoolTeacherList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogReturnVisible = false">取 消</el-button>
        <el-button type="primary" @click="addArticleFilter">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  GetPowerApi,
  GetUserPowerApi,
  GetThisSchoolTeacherDataApi,
  TransferOfIdentityApi,
  UpdateUserPowerApi,
  GetAdminListApi
} from "@/request/requestApi";
import addAdmin from "./components/addAdmin.vue";
export default {
  components: {
    addAdmin
  },
  data() {
    return {
      schoolList:[],
      sensitiveTeacher: "",
      schoolTeacherList: [],
      sensitiveSchool: "",
      isSee: false,
      popTitle: "",
      dialogVisible: false,
      teacherList: [],
      currAdminInfo: {},
      dialogFormVisible: false,
      dialogReturnVisible: false,
      currUser: "",
      currAuthArr: [],
      authTitle: "权限设置",
      authDialog: false,
      props: {
        label: "name"
      },
      childDatas: [],
      AuthTreeData: [],
      tableData: [],
      formInline: {
        schoolId:"",
        keyWord: "",
        dateValue: "",
        type: ""
      },
      //翻页
      currentPage: 1,
      currentSize: 10,
      totalCount: 0,
      //类型
      typeList: [
        { name: "校级管理员", value: 0 },
        { name: "教职工管理员", value: 1 },
        { name: "学生管理员", value: 2 }
      ]
    };
  },
  created() {
    this.getSchoolList()
    if (this.$route.params.adminType || this.$route.params.schoolId) {
      this.formInline.type = this.$route.params.adminType;
      this.formInline.schoolId = this.$route.params.schoolId;
    }
    if (this.$route.params.pageIdx || this.$route.params.pageSize) {
      this.currentPage=this.$route.params.pageIdx
      this.currentSize=this.$route.params.pageSize
      this.getAdminList(this.currentPage, this.currentSize);
    } else {
    this.getAdminList();
    }
  },
  mounted() {},
  methods: {
        //获取学校
        getSchoolList(pageIndex = 1, pageSize = 9999999) {
      var params = {
        PageIndex: pageIndex,
        PageSize: pageSize
      };

      var url = this.$dataConver.getUrl("/admin/School/GetSchoolList", params);

      this.$api.get(url).then(res => {
        if (res.succeed) {
          this.schoolList = res.data.items;
        } else {
          this.$message.error(res.error);
        }
      });
    },
    async getTransTeacherList() {
      let res = await GetThisSchoolTeacherDataApi();
      if (res.succeed) {
        this.schoolTeacherList = res.data;
      }
    },
    async addArticleFilter() {
      this.$confirm("确定转让身份给此管理员吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          let params = { id: this.sensitiveTeacher };
          let res = await TransferOfIdentityApi(params);
          if (res.succeed) {
            this.$message.success("操作成功");
            this.dialogReturnVisible = false;
            this.getAdminList();
            setTimeout(() => {
              localStorage.setItem("userinfo", "");
            localStorage.setItem("role", "");
            localStorage.setItem("navIndex", "");
            localStorage.setItem("questionList", "");
            localStorage.setItem("token", "");
            localStorage.setItem("userPermissions", "");
            this.$store.commit("removeInfo", "");
            this.$router.push({ name: "login" });
            }, 200);
          }
        })
        .catch(() => {});
    },
    resetForm() {},
    setAdmin(type) {
      this.$refs.schoolDetail.addAdminHandle(type);
    },
    // async getAdminList() {
    //   let res = await GetAdminListApi({ PageSize: 999999 })
    //   if (res.succeed) {
    //   this.teacherList = res.data.item1
    // }
    //  },
    openSuerPop() {
      this.dialogVisible = true;
    },
    closeAddForm() {
      this.currAdminInfo = {};
    },
    closeReturnVisible() {
      this.sensitiveTeacher = "";
      this.dialogReturnVisible = false;
    },
    closeDetials() {
      this.dialogFormVisible = false;
    },
    //修改
    amendDetials() {
      this.$refs.schoolDetail.determineHandle();
    },
    amendDetials2() {
      this.$refs.schoolDetail.addAdminHandle(true);
    },
    onEditAuth() {
      let arr = this.$refs.areaTrees
        .getCheckedKeys()
        .concat(this.$refs.areaTrees.getHalfCheckedKeys());
      const data = arr.map(item => {
        return {
          userId: this.currUser.userId,
          powerId: item
        };
      });
      UpdateUserPowerApi(data).then(res => {
        if (res.succeed) {
          this.$message.success("权限更新成功");
          this.authDialog = false;
        }
      });
    },
    collegeAuth() {
      // 使用 reduce 方法提取 isNotSelected 为 false 的 id
      const selectedIds = this.AuthTreeData.reduce((acc, item) => {
        if (item.isNotSelected) {
          acc.push(item.id); // 添加顶层 id
        }
        if (item.children) {
          item.children.forEach(child => {
            if (child.isNotSelected) {
              acc.push(child.id); // 添加子项 id
            }
          });
        }
        return acc;
      }, []);
      this.currAuthArr = selectedIds;
    },
    // 复选框的check事件
    handleCheck(data, checked, indeterminate) {
      let nodes = this.getNodeById(data.id);
      this.nodeClick(data, nodes);
    },
    getNodeById(nodeId) {
      const node = this.$refs.areaTrees.getNode(nodeId);
      return node;
    },
    nodeClick(data, node) {
      //这个方法是勾选父级子级也默认勾选 取消子级不影响父级
      this.childNodesChange(node);
      // 这个方法是勾选子级默认把父级也勾选上
      this.parentNodesChange(node);
      // this.$refs.Tree.getCheckedNodes() 这个方法是官网自带的 若节点可被选择（即    show-checkbox 为 true），则返回目前被选中的节点所组成的数组
      this.arr = this.$refs.areaTrees.getCheckedNodes();
      let list = [];
      this.arr.forEach(item => {
        list.push(item.id);
      });
    },
    childNodesChange(node) {
      console.log(node.checked, node.childNodes);
      let len = node.childNodes.length;
      if (len > 0) {
        for (let i = 0; i < len; i++) {
          if (!node.childNodes[i].data.disabled) {
            if (!node.checked) {
              node.childNodes[i].checked = false;
            } else {
              node.childNodes[i].checked = true;
            }
          }
          this.childNodesChange(node.childNodes[i]);
        }
      }
    },
    parentNodesChange(node) {
      if (node.parent) {
        for (let key in node) {
          if (key == "parent") {
            node[key].checked = true;
            this.parentNodesChange(node[key]);
          }
        }
      }
    },
    async openAuth(row) {
      this.currUser = row;
      await this.getAllPermissionData(row.userId);
      this.authDialog = true;
    },
    //获取全部权限数据
    async getAllPermissionData(id) {
      let res = await GetUserPowerApi({ userId: id });
      if (res.succeed) {
        this.AuthTreeData = res.data;
        this.AuthTreeData.forEach(item => {
          if (item.name == "首页") {
            item.disabled = true;
          }
          item.children.forEach(item => {
            // if (
            // item.name == "学校管理" ||
            // item.name == "企业认证"
            // ||
            // item.name == "管理员管理"
            // item.name == "管理员管理"
            // ) {
            //   item.disabled = true;
            // }
          });
        });
        this.collegeAuth();
        // this.AuthTreeData.forEach(item => {
        //   if (item.name == "首页") {
        //     item.disabled = true;
        //     // item.children.forEach(item=>{
        //     //   item.disabled = true
        //     // })
        //   }
        // });
        // this.childDatas = this.handleTreeFn(this.AuthTreeData);
      }
    },
    // 处理树形数据 筛选出叶子节点
    handleTreeFn(treeData) {
      let targetArr = [];
      const deepFn = arr => {
        arr.forEach(x => {
          if (x.children.length) {
            deepFn(x.children);
          } else {
            targetArr.push(x);
          }
        });
      };
      deepFn(treeData);
      return targetArr;
    },
    searcList() {
      this.currentPage = 1;
      this.getAdminList(this.currentPage);
    },
    getAdminList(pageIndex = 1, pageSize = 10) {
      if (
        this.isNull(this.formInline.keyWord) &&
        !this.isNull(this.formInline.dateValue)
      ) {
        this.$api
          .get(
            "/api/AdminManagement/GetAdminList?PageIndex=" +
              pageIndex +
              "&PageSize=" +
              pageSize +
              "&Item1.StartTime=" +
              this.formInline.dateValue[0] +
              "&Item1.EndTime=" +
              this.formInline.dateValue[1] +
              "&Item1.AdminType=" +
            this.formInline.type +
            "&Item1.SchoolId=" +
              this.formInline.schoolId
          )
          .then(res => {
            if (res.succeed) {
              this.tableData = res.data.item1;
              this.totalCount = res.data.item2;
              console.log(this.tableData);
            } else {
              this.$message.error(res.error);
            }
          });
      } else if (
        !this.isNull(this.formInline.keyWord) &&
        this.isNull(this.formInline.dateValue)
      ) {
        this.$api
          .get(
            "/api/AdminManagement/GetAdminList?PageIndex=" +
              pageIndex +
              "&PageSize=" +
              pageSize +
              "&Keyword=" +
              this.formInline.keyWord +
              "&Item1.AdminType=" +
              this.formInline.type+
            "&Item1.SchoolId=" +
              this.formInline.schoolId
          )
          .then(res => {
            if (res.succeed) {
              this.tableData = res.data.ietm1;
              this.totalCount = res.data.ietm2;
              console.log(this.tableData);
            } else {
              this.$message.error(res.error);
            }
          });
      } else if (
        this.isNull(this.formInline.keyWord) &&
        this.isNull(this.formInline.dateValue)
      ) {
        this.$api
          .get(
            "/api/AdminManagement/GetAdminList?PageIndex=" +
              pageIndex +
              "&PageSize=" +
              pageSize +
              "&Item1.AdminType=" +
              this.formInline.type+
            "&Item1.SchoolId=" +
              this.formInline.schoolId
          )
          .then(res => {
            if (res.succeed) {
              this.tableData = res.data.item1;
              this.totalCount = res.data.item2;
              console.log(this.tableData);
            } else {
              this.$message.error(res.error);
            }
          });
      } else {
        this.$api
          .get(
            "/api/AdminManagement/GetAdminList?PageIndex=" +
              pageIndex +
              "&PageSize=" +
              pageSize +
              "&Keyword=" +
              this.formInline.keyWord +
              "&Item1.StartTime=" +
              this.formInline.dateValue[0] +
              "&Item1.EndTime=" +
              this.formInline.dateValue[1] +
              "&Item1.AdminType=" +
              this.formInline.type+
            "&Item1.SchoolId=" +
              this.formInline.schoolId
          )
          .then(res => {
            if (res.succeed) {
              this.tableData = res.data.item1;
              this.totalCount = res.data.item2;
              console.log(this.tableData);
            } else {
              this.$message.error(res.error);
            }
          });
      }
    },
    handleClick(val) {
      this.$router.push({
        path: "/userManagement/userDetail",
        query: { role: "admin", id: val.userId ,pageIdx: this.currentPage, pageSize:this.currentSize}
      });
    },
    //撤销 管理员
    cancelGLY(val) {
      this.$confirm("确定撤销此管理员吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          let query = {
            id: val.id
            // schoolId: val.schoolId,
            // reason: value
          };
          console.log(query);
          this.$api
            .post("/api/AdminManagement/RevokeAdmin", query)
            .then(res => {
              if (res.succeed) {
                this.$message.success("操作成功！");
                this.getAdminList();
              } else {
                this.$message.error(res.error);
              }
            });
        })
        .catch(() => {});
    },
    addAdminBtn(val) {
      this.dialogFormVisible = true;
      this.isSee = false;
      this.popTitle = "添加管理员";
    },
    closeAdminBtn(val) {
      this.dialogVisible = false;
      this.dialogFormVisible = false;
      this.getAdminList();
    },
    uploadAuth(val) {
      console.log(val);
      this.currAdminInfo = val;
      this.dialogFormVisible = true;
      this.popTitle = "上传认证信息";
      this.isSee = true;
    },
    async returnAuth(val) {
      await this.getTransTeacherList();
      this.dialogReturnVisible = true;
    },
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.currentPage = 1;
      this.currentSize = val;
      this.getAdminList(this.currentPage, this.currentSize);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
      this.currentPage = val;
      this.getAdminList(this.currentPage, this.currentSize);
    },
    //判空方法
    isNull(val = "") {
      if (val == undefined || val == null) {
        return true;
      }
      var str = val.toString().replace(/(^\s*)|(\s*$)/g, ""); //去除空格;
      if (str == "" || str == undefined || str == null) {
        return true;
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.table {
  margin-top: 0.2rem;
  padding: 0.24rem 0.19rem 0.3rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
}
.filter {
  margin-top: 0.3rem;
  padding: 0.25rem 0.19rem 0.23rem 0.2rem;
  background-color: rgb(255, 255, 255);
  border-radius: 0.05rem;
  display: flex;
  justify-content: space-between;
  >>> .el-form-item {
    margin-bottom: 0;
  }
}
.section {
  padding: 0.23rem 0.18rem 0.57rem;
  flex: 1 1 2.4rem;
  border-radius: 0.06rem;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  height: 1.4rem;
  .name {
    color: rgb(102, 102, 102);
    font-size: 0.18rem;
    font-family: Microsoft YaHei;
    line-height: 0.17rem;
  }
  .number {
    margin-top: 0.17rem;
    color: rgb(51, 51, 51);
    font-size: 0.32rem;
    font-family: Microsoft YaHei;
    line-height: 0.26rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/view/userManagement/admin.vue